import { Component, inject } from '@angular/core';
import { SanitaryClassificationService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SanitaryClassificationCreateDto,
  SanitaryClassificationDto,
  SanitaryClassificationExcelDownloadDto,
  SanitaryClassificationUpdateDto,
} from '../proxy/planning/dtos/sanitary-classification';
import { SANITARYCLASSIFICATION_CONFIG, SANITARYCLASSIFICATION_FIELDS } from './sanitary-classification.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sanitary-classification',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SanitaryClassificationService, ConfirmationService],
  templateUrl: './sanitary-classification.html',
  styleUrl: './sanitary-classification.scss',
})
export class SanitaryClassification extends BaseCrudComponent<
  SanitaryClassificationDto,
  SanitaryClassificationCreateDto,
  SanitaryClassificationUpdateDto,
  SanitaryClassificationExcelDownloadDto
> {
  service = inject(SanitaryClassificationService);
  config = SANITARYCLASSIFICATION_CONFIG;
  fields = SANITARYCLASSIFICATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: SanitaryClassificationDto): SanitaryClassificationUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SanitaryClassification';
  }
}
